import profile from './portfolio.JPG';
import reactImg from './react.jpg';
import jsImg from './js.jpg';
import pythonImg from './python.jpg';
import htmlImg from './html.jpg';
import cssImg from './css.jpg';
import mysqlImg from './mysql.jpg';
import javaImg from './java.jpg';
import jenkins from './jenkins.jpg'
import admin from './admin_ui.png';

const images = {
    profile,
    reactImg,
    jsImg,
    pythonImg,
    htmlImg,
    cssImg,
    mysqlImg,
    javaImg,
    jenkins,
    admin
}

export default images;